import React from 'react';
import AltovaProductTileHolder from './tiles/AltovaProductTileHolder';
import './tiles/tiles.scss';
import './altova.scss';
import altovaTrainingPartner from '../assets/images/altova/logos/altovaPartner.gif';
import altovaConsultPartner from '../assets/images/altova/logos/altovaPartnerConsult.gif';
import { Helmet} from 'react-helmet-async';


function Altova() {
  // Altova product data for tiles
  const altovaProducts = [
    {
      id: 'missionkit',
      title: 'Altova MissionKit',
      content: 'MissionKit is a software development suite of enterprise-class XML, SQL, and UML tools for information architects and application developers.',
      image: '/assets/images/altova/logos/missionkit.svg',
      url: 'https://www.altova.com/missionkit'
    },
    {
      id: 'xmlspy',
      title: 'XMLSpy',
      content: 'XML Spy is the tool of choice for our XML training programs. We provide consulting on the best approaches to using this tool within a project.',
      image: '/assets/images/altova/logos/xmlspy.svg',
      url: 'https://www.altova.com/xmlspy'
    },
    {
      id: 'mapforce',
      title: 'MapForce',
      content: 'We help customers use MapForce for database integration projects, automated invoicing systems, and genomic data mapping. We also provide MapForce training.',
      image: '/assets/images/altova/logos/mapforce.svg',
      url: 'https://www.altova.com/mapforce'
    },
    {
      id: 'stylevision',
      title: 'StyleVision',
      content: 'Stylevision is taught as part of our XSLT Training course. In addition we also develop and maintain stylesheets for our customers as well as consulting.',
      image: '/assets/images/altova/logos/stylevision.svg',
      url: 'https://www.altova.com/stylevision'
    },
    {
      id: 'umodel',
      title: 'UModel',
      content: 'UML modelling is a subject that our team are very proficient in and we offer UML training and consulting using the UModel tool as the modelling tool of choice.',
      image: '/assets/images/altova/logos/umodel.svg',
      url: 'https://www.altova.com/umodel'
    },
    {
      id: 'mobiletogether',
      title: 'Mobile Together',
      content: 'MobileTogether Server is the back-end hub for customers\' mobile apps and acts as a gateway between mobile users and your back-end.',
      image: '/assets/images/altova/logos/mobiletogether.svg',
      url: 'https://www.altova.com/mobiletogether'
    },
    {
      id: 'flowforceserver',
      title: 'FlowForce Server',
      content: 'FlowForce Server is the high-performance server for multi-step, enterprise-level data aggregation, processing, and reporting tasks. Contact us for more information.',
      image: '/assets/images/altova/logos/flowforce_server.svg',
      url: 'https://www.altova.com/flowforceserver'
    },
    {
      id: 'databasespy',
      title: 'DatabaseSpy',
      content: 'DatabaseSpy 2017 is the unique multi-database query, design, compare, and convert tool from the creators of XMLSpy. Contact us for more information.',
      image: '/assets/images/altova/logos/databasespy.svg',
      url: 'https://www.altova.com/databasespy'
    }
  ];  return (
    <>
      <Helmet>
          <title>Altova Training & Consulting Partner | MapForce, FlowForce & StyleVision | Watchelm</title>
          <meta name="description" content="Watchelm is an Altova training and consulting partner, delivering expert courses and workshops on XML, MapForce, StyleVision and related tools. We design tailored Altova training programs for technical teams across the UK and Europe." />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Service",
              "name": "Altova Training and Consulting",
              "description": "Watchelm provides specialist Altova training and consulting services, including tailored courses and workshops on XML, MapForce, StyleVision and related tools for technical teams in enterprises.",
              "provider": {
                "@type": "Organization",
                "name": "Watchelm Consulting Ltd",
                "url": "https://www.watchelm.com"
              },
              "areaServed": [
                { "@type": "Country", "name": "United Kingdom" },
                { "@type": "Country", "name": "Germany" },
                { "@type": "Country", "name": "France" }
              ],
              "serviceType": "Altova training and consulting",
              "audience": {
                "@type": "BusinessAudience",
                "description": "Technical teams and enterprises using Altova tools for XML, data mapping and reporting."
              }
            })}
          </script>
          <link rel="canonical" href="https://www.watchelm.com/altova"></link>
      </Helmet>
    {/* Altova products tiles section */}
    <section className="products-section">
        <div className="container">
            <h2 className="section-title">Altova Product Training & Consulting</h2>
            <AltovaProductTileHolder tileContents={altovaProducts} />
        </div>
    </section>

    {/* Partner credentials section */}
    <section className="altova-partner-section">
        <div className="container">
            <div className="partner-content">
                <div className="partner-badges">
                    <div className="badge-item">
                        <img src={altovaTrainingPartner} alt="Altova Training Partner" />
                        <div className="badge-text">
                            <h4>Training Partner</h4>
                            <p>Certified to deliver professional Altova training programs</p>
                        </div>
                    </div>
                    <div className="badge-item">
                        <img src={altovaConsultPartner} alt="Altova Consulting Partner" />
                        <div className="badge-text">
                            <h4>Consulting Partner</h4>
                            <p>Authorized to provide expert Altova consulting services</p>
                        </div>
                    </div>
                </div>
                <div className="partner-description">
                    <h2>Altova Partnership Excellence</h2>
                    <p>
                        Watchelm is an Altova training and consulting partner, specialising in XML, MapForce, StyleVision and related tools. We design tailored Altova training programs for technical teams across the UK and Europe.

                    </p>
                    <p>
                        Our consultants have been providing consulting and teaching on Altova MapForce 
                        and the other related products since 2002. We consult and teach right across 
                        the Altova product range, providing consultancy to various financial, logistics, 
                        academic, and medical organisations on the best approach to the integration of 
                        Altova products within their organisations.
                    </p>
                </div>
            </div>
        </div>
    </section>
</>
    );

}

export default Altova;